<table class="table table-borderless table-striped" [dir]="languageService.getDir()"
       [class.text-right]="languageService.isCurrent('Hebrew')">
  <tbody>
  <tr>
    <td>{{ 'PROFILE.NAME' | translate}}</td>
    <td>{{ currentUser.name }}</td>
    <td></td>
  </tr>
  <tr>
    <td>{{ 'PROFILE.PHONE' | translate}}</td>
    <td dir="ltr">
      {{ currentUser.phone.value }}
      <span class="badge badge-pill badge-success" *ngIf="currentUser.phone.status == 'VERIFIED'">
        {{ 'PROFILE.VERIFIED' | translate }}
      </span>
      <span class="badge badge-pill badge-danger" *ngIf="currentUser.phone.status == 'UNVERIFIED'">
        {{ 'PROFILE.UNVERIFIED' | translate }}
      </span>
    </td>
    <td class="text-center">
      <button type="button" *ngIf="currentUser.phone.value" class="btn btn-sm option-button"
              [routerLink]="['/user/phone/update']">
        <i class="fa fa-pencil"></i>
      </button>
      <button type="button" *ngIf="!currentUser.phone.value" class="btn btn-sm option-button"
              [routerLink]="['/user/phone/update']">
        <i class="fa fa-plus"></i>
      </button>
      <button type="button" *ngIf="currentUser.phone.value && currentUser.phone.status == 'UNVERIFIED'"
              class="btn btn-sm option-button"
              [routerLink]="['/user/phone-verification']">{{ 'PROFILE.VERIFY' | translate }}</button>
    </td>
  </tr>
  <tr>
    <td>{{ 'PROFILE.EMAIL' | translate }}</td>
    <td dir="ltr">
      {{ currentUser.email.value }}
      <span class="badge badge-pill badge-success" *ngIf="currentUser.email.status == 'VERIFIED'">
        {{ 'PROFILE.VERIFIED' | translate }}
      </span>
      <span class="badge badge-pill badge-danger" *ngIf="currentUser.email.status == 'UNVERIFIED'">
        {{ 'PROFILE.UNVERIFIED' | translate }}
      </span>
    </td>
    <td class="text-center">
      <!-- TODO make it work -->
      <div class="ml-2" *ngIf="currentUser.email.status == 'UNVERIFIED'">
        <a [routerLink]="['/user/email-verification']" class="btn btn-sm option-button">Verify</a>
      </div>
    </td>
  </tr>
  <tr>
    <td>{{ 'PROFILE.ACTIVE_ORDERS' | translate }}</td>
    <td>{{ currentUser.activeOrders }}</td>
    <td></td>
  </tr>
  <tr>
    <td>{{ 'PROFILE.STATUS' | translate }}</td>
    <td>{{ currentUser.userStatus }}</td>
    <td></td>
  </tr>
  <tr>
    <td>{{ 'PROFILE.REGISTRATION_DATE' | translate }}</td>
    <td>{{ currentUser.registrationDate | date:'dd.MM.yyyy HH:mm:ss'}}</td>
    <td></td>
  </tr>
  <tr *ngIf="isAdmin">
    <td>Bonus:</td>
    <td>You have {{ currentUser.coffeeCups }} free cup(s) of coffee</td>
    <td class="text-center">
      <div class="ml-2" *ngIf="currentUser.coffeeCups > 0">
        <a [routerLink]="['/user/coffee']" class="btn btn-sm option-button">Use</a>
      </div>
    </td>
  </tr>
  <tr>
    <td>{{ 'PROFILE.LANGUAGE' | translate}}</td>
    <td>
      <div class="lang-selector">
        <select #selLang (change)="languageService.switchLanguage(selLang.value)">
          <option *ngFor="let language of languageService.getLangs()"
                  [value]="language"
                  [selected]="languageService.isCurrent(language)">{{ language }}</option>
        </select>
      </div>
    </td>
    <td></td>
  </tr>
  </tbody>
</table>
